// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__19-__","loading":"Loading_loading__25dqG"};